import { apiService } from "../../../core/api";
import { API_ENDPOINTS } from "../../../core/constants/endpoints";
import {
  PartnersApiResponse,
  PartnerResponse,
  PartnerDetailResponse,
  PartnerDetailApiResponse,
  PartnerFilters,
  UsersApiResponse,
  PartnersGeneralDataApiResponse,
} from "../model/types";

export class PartnersService {
  async getAllPartners(filters?: PartnerFilters): Promise<PartnersApiResponse> {
    let queryParts: string[] = [];

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          // For comma-separated values, don't encode the commas
          if (typeof value === "string" && value.includes(",")) {
            queryParts.push(`${encodeURIComponent(key)}=${value}`);
          } else {
            queryParts.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
            );
          }
        }
      });
    }

    const queryString = queryParts.join("&");
    const url = queryString
      ? `${API_ENDPOINTS.PARTNERS.GET_ALL}?${queryString}`
      : API_ENDPOINTS.PARTNERS.GET_ALL;

    return apiService.get<PartnersApiResponse>(url);
  }

  async getPartnerById(id: string): Promise<PartnerDetailResponse> {
    const response = await apiService.get<PartnerDetailApiResponse>(
      API_ENDPOINTS.PARTNERS.GET_BY_ID(id),
    );
    return response.data;
  }

  async getFollowedUsers(): Promise<UsersApiResponse> {
    return apiService.get<UsersApiResponse>(`${API_ENDPOINTS.USER.USERS}`);
  }
  async getFollowers(): Promise<UsersApiResponse> {
    return apiService.get<UsersApiResponse>(
      `${API_ENDPOINTS.USER.MY_NETWORK}/?type=followers`,
    );
  }

  async getMyNetworkUsers(page: number = 1): Promise<UsersApiResponse> {
    const url = `${API_ENDPOINTS.USER.USERS}?page=${page}`;
    return apiService.get<UsersApiResponse>(url);
  }

  async searchUsers(
    searchQuery: string,
    page: number = 1,
  ): Promise<UsersApiResponse> {
    const url = `${API_ENDPOINTS.USER.USERS}?search=${encodeURIComponent(searchQuery)}&page=${page}`;
    return apiService.get<UsersApiResponse>(url);
  }

  async getUsersWithFilters(
    filters?: PartnerFilters,
    page: number = 1,
  ): Promise<UsersApiResponse> {
    let queryParts: string[] = [];

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          // For comma-separated values, don't encode the commas
          if (typeof value === "string" && value.includes(",")) {
            queryParts.push(`${encodeURIComponent(key)}=${value}`);
          } else {
            queryParts.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
            );
          }
        }
      });
    }

    const queryString = queryParts.join("&");
    const url = queryString
      ? `${API_ENDPOINTS.USER.USERS}?${queryString}&page=${page}`
      : `${API_ENDPOINTS.USER.USERS}?page=${page}`;

    return apiService.get<UsersApiResponse>(url);
  }

  async getNetworkFollowers(): Promise<UsersApiResponse> {
    return apiService.get<UsersApiResponse>(
      `${API_ENDPOINTS.USER.MY_NETWORK}/?type=followers`,
    );
  }

  async getNetworkFollowing(): Promise<UsersApiResponse> {
    return apiService.get<UsersApiResponse>(
      `${API_ENDPOINTS.USER.MY_NETWORK}/?type=following`,
    );
  }

  async toggleMemberFollow(
    memberId: string,
    isFollowing: boolean,
  ): Promise<void> {
    // console.log(
      // "Toggling follow status for memberId:",
      // memberId,
      // "isFollowing:",
      // isFollowing,
    // );
    return await apiService.post(API_ENDPOINTS.USER.FOLLOW, {
      action_mode: isFollowing ? "remove" : "add",
      follow_uid: memberId,
    });
  }

  async getPartnersGeneralData(): Promise<PartnersGeneralDataApiResponse> {
    return apiService.get<PartnersGeneralDataApiResponse>(
      API_ENDPOINTS.PARTNERS.GET_PARTNERS_GENERAL_DATA,
    );
  }
}

export const partnersService = new PartnersService();
